export class SparkEngineStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<SparkEngineStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<SparkEngineStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkEngineStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
